import { dispatch } from 'store'
import { editorThunks } from 'store/features/editor/thunks'
import { useRef } from 'react'
import Selecto from 'react-selecto'
import { TSelectoItems } from 'common-components/ReactSelecto/types'

export const useReactSelectoHandlers = () => {
  const selectoRef = useRef<Selecto>(null)

  const onAdd = (items: TSelectoItems) => {
    dispatch(editorThunks.setAsideOverlayContent(null))
    dispatch(editorThunks.addActiveTimelineItems(items))
  }

  const onRemove = (ids: string[], isRemovingLastItem: boolean) => {
    dispatch(editorThunks.removeActiveTimelineItems(ids))
    if (isRemovingLastItem) {
      dispatch(editorThunks.setAsideOverlayContent(null))
    }
  }

  return { onAdd, onRemove, selectoRef }
}
